import { Api } from "../../../../shared/services/Api";
import Contact from "../../models/Contact";

export default class ContactService extends Api {
    public async postContact(contact: Contact, captcha: string | null): Promise<any> {
        return await this.post('/contact', { contact, captcha });
    }
}